import { Phone, Mail } from "lucide-react";
import { PageHero } from "../components/SectionHeading";
import { FaqList } from "../components/FaqList";
import { CtaBand } from "../components/CtaBand";
import { useBrand } from "../context/BrandContext";

export default function Faq() {
  const b = useBrand();
  return (
    <>
      <PageHero testid="faq-hero" eyebrow="FAQ" title="Questions, answered" sub="Practical answers about timing, payment, inspections, tracking and coverage." />
      <section className="py-20 md:py-28">
        <div className="container-x grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-8"><FaqList /></div>
          <aside className="lg:col-span-4 panel p-7 h-fit lg:sticky lg:top-32" data-testid="faq-contact-card">
            <div className="font-display font-bold uppercase text-slate-900 text-2xl">Still have questions?</div>
            <p className="mt-3 text-sm text-slate-600">Our coordinators are happy to walk you through your shipment.</p>
            <a href={`tel:${b.phone_tel}`} className="btn-amber w-full mt-6" data-testid="faq-call-button"><Phone className="w-4 h-4" />{b.phone_display}</a>
            <a href={`mailto:${b.email}`} className="btn-ghost w-full mt-3 normal-case text-xs" data-testid="faq-email-button"><Mail className="w-4 h-4" />{b.email}</a>
          </aside>
        </div>
      </section>
      <CtaBand />
    </>
  );
}
